import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function StickyPhoneBar() {
  return <div className="fixed bottom-0 left-0 right-0 z-50" data-id="element-182">
      <a href="tel:+19252151160" className="flex items-center justify-center gap-2 w-full bg-gold hover:bg-[#A6844E] text-white font-bold uppercase tracking-wider py-4 text-sm transition-all duration-300" data-id="element-183">
        <PhoneIcon size={16} data-id="element-184" />
        <span data-id="element-185">(925) 215-1160</span>
      </a>
    </div>;
}